var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"1260px","margin":"0 auto"},style:(_vm.css)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }